
import { defineComponent, PropType, ref, computed } from "vue";
export default defineComponent({
  name: "ChipsNumberArrayInput",
  props: {
    input: { type: Object as PropType<any>, required: true },
    modelValue: { type: Array as PropType<number[]>, default: () => [] },
  },
  emits: ["update:modelValue", "add", "remove"],
  setup(props, { emit }) {
    const temp = ref<number | null>(null);
    const model = computed({
      get: () => props.modelValue,
      set: (v) => emit("update:modelValue", v),
    });
    const addTier = () => {
      if (temp.value != null && !isNaN(temp.value)) {
        emit("add", temp.value);
        temp.value = null;
      }
    };
    return { temp, model, addTier };
  },
});
